import React, { useState } from 'react'
import '../MyProfile/editMyProfile.css'
import { useForm } from "react-hook-form";
import EditDisabled from './EditDisabled';
import ChangeRequest from './ChangeRequest';
import { IP } from '../internalServer';

let substr;
let classStr;
let subtec;

export default function EditMyProfile({ setClick, setProfile, setEdit2, userInfo }) {
  const [discard, setDiscard] = useState()
  const [editSucess, setEditSucess] = useState()


  let dobchng = userInfo?.date_of_birth.replace(/T/g, "-");
  let dobarr = dobchng.split("-", 3);

  const CTRole_Information = localStorage.getItem("role_as_class_teacher");
  const CoRole_Information = localStorage.getItem("role_as_co_ordinator");
  const general_role = localStorage.getItem("general_role");
  const jsonRole_CTinformation = JSON.parse(CTRole_Information);
  const jsonRole_Coinformation = JSON.parse(CoRole_Information);
  const jsonRole_Geinformation = JSON.parse(general_role);
  let SchoolId = JSON.parse(localStorage.getItem("School_id"));

  const cthelper = () => {
    jsonRole_CTinformation?.forEach(function (item) {
      if (item.is_class_teacher === true) {
        substr = [];
        let std = item.standard_id.name;
        let sec = item.section_id.name;
        item.subjects_id.forEach(function (obj) {
          let sub = obj.name;
          let str = "Class".concat(" ", std, "-", sec, "_", sub);
          substr.push(str);
          // console.log(str);
        });
        //console.log("hello",substr);
        // setClassTeacherOf(substr);
      }
    });
  };
  const cordinator = () => {
    classStr = [];
    jsonRole_Coinformation?.forEach(function (item) {
      if (item.is_class_co_ordinator === true) {
        let std1 = item.standard_id.name;
        let str = "Class".concat("-", std1);
        classStr.push(str);
      }
    });
  };
  const subjTeacher = () => {
    subtec = [];
    jsonRole_Geinformation?.forEach((item) => {
      if (
        item.is_class_co_ordinator === false &&
        item.is_class_teacher === false
      ) {
        let std = item.standard_id.name;
        let sec = item.section_id.name;
        item.subjects_id.forEach(function (obj) {
          let sub = obj.name;
          let str = "Class".concat(" ", std, "-", sec, "_", sub);
          subtec.push(str);
          // console.log(str);
        });
      }
    });
  };
  cthelper();
  cordinator();
  subjTeacher();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
  } = useForm();


  const onSubmit1 = (data) => {

    if (data === true) {
      setEditSucess(true)
    }

    reset();
  };


  return (
    <>

      <div id='profile_all_Container' >
        <div className='total_header_profile'>
          <div className='heading_name_profile'>
            My profile
          </div>
          <div>
            <img onClick={(e) => { setClick(false); setProfile(false); setEdit2(false) }} src='/DCM-img/cross_arrow.png' alt='cross logo'></img>
          </div>
        </div>
        <div className='detail_all_profile'>
          <form onSubmit={handleSubmit(onSubmit1)}>
            <div className='profile_img'>
              <div class="d-flex">
                {/* <img src={`${  userInfo?.profile_picture
                              ? `${IP}${userInfo.profile_picture.substring(
                                userInfo.profile_picture.indexOf("/")
                                )}`
                              : "/DCM-img/Profile_photo.png"
                          }`} alt='ProfilePhoto'/> */}
                <img
                  src={
                    userInfo?.profile_picture
                      ? IP + userInfo?.profile_picture.replace(/^\./, "")
                      : userInfo?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : userInfo?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default-profile.png"
                  }
                  alt='icon'
                  className="profilePicImg"
                  style={{ width: "55px", height: "54px", borderRadius: "50%" }}
                  onError={(e) => {
                    // This function will run if the image fails to load
                    if (userInfo?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg";
                    } else if (userInfo?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png";
                    } else {
                      e.target.src = "/images/default-profile.png";
                    }
                  }}
                />
                {/* <img src='/DCM-img/Profile_photo.png' alt='ProfilePhoto'></img> */}
                <div className='Student_name'>
                  {userInfo?.name}
                </div>
              </div>
            </div>



            <div className='all_one_n col-8'>
              <div>
                <div className='gender_class '>
                  <div >
                    <div className='gender'>
                      Gender
                    </div>
                    <div className='male_H'>
                      {userInfo?.gender === "M" ? "Male" : "Female"}
                    </div>
                  </div>

                </div>

                <div className='contact_class '>
                  <div className='gender_class '>
                    <div className='gender'>
                      School email id
                    </div>
                    <div className='male_H'>
                      {userInfo?.personal_email}
                    </div>
                  </div>

                </div>

                <div className='gender_class '>
                  <div class=''>
                    <div className='gender'>
                      School id
                    </div>
                    <div className='male_H'>
                      {SchoolId}
                    </div>
                  </div>

                </div>


                <div className='gender_class '>
                  {/* <div >
                  <div className='gender'>
                    Class
                  </div>
                  <div className='total_class_N'>
                    <button className='btn_claasName'>Class 9-B</button>
                    <button className='btn_claasName'>Class 10-D</button>
                  </div>
                </div> */}
                </div>
              </div>

              <div className='left_dob' >
                <div className='gender_class ' >
                  <div className='gender'>
                    DOB
                  </div>
                  <div className='Dob_date'>
                    {dobarr[2]}
                    {"-"}
                    {dobarr[1]}
                    {"-"}
                    {dobarr[0]}
                  </div>
                </div>
                <div className='gender_class '>
                  <div className='gender'>
                    Contact number
                  </div>
                  <div className='d-flex'>
                    <input id='EContact'
                      className={`form-control ${errors.email && "invalid"}`}
                      {...register("Contact", {
                        required: "Phone is Mandatory",
                        pattern: {
                          value: /^(\+\d{1,3}[- ]?)?\d{10}$/,
                          message: "Invalid Contact Number",
                        }
                      })}
                      onKeyUp={() => {
                        trigger("Contact");
                      }}
                    />

                    <img className='pencil-img' src='/DCM-img/input-pencil.png' alt='pencil logo'></img>
                  </div>
                  {errors.Contact && (
                    <small className="text-danger">{errors.Contact.message}</small>
                  )}
                </div>
                <div className='gender_class '>
                  <div className='gender'>
                    Emergency contact number
                  </div>

                  <div className='d-flex'>
                    {/* <input required id='EContact' class="form-control" type='number'></input> */}
                    <input id='EContact' class="form-control" type='number'
                      className={`form-control ${errors.email && "invalid"}`}
                      {...register("email", {
                        required: "Emergency contact is Mandatory",
                        pattern: {
                          value: /^(\+\d{1,3}[- ]?)?\d{10}$/,
                          message: "Invalid Emergency contact ",
                        }
                      })}
                      onKeyUp={() => {
                        trigger("email");
                      }}
                    />
                    <img className='pencil-img' src='/DCM-img/input-pencil.png' alt='pencil logo'></img>
                  </div>
                  {errors.email && (
                    <small className="text-danger">{errors.email.message}</small>
                  )}
                </div>
                <div className='gender_class ' >
                  <div className='gender'>
                    Address
                  </div>

                  <div className='d-flex'>
                    <input id='EContact' class="form-control" type='text'></input>

                    <img className='pencil-img' src='/DCM-img/input-pencil.png' alt='pencil logo'></img>
                  </div>

                </div>
              </div>
            </div>







            <div class="row mt-3">

              <div className='gender'>
                Class handling
              </div>


              <div class="ml-3 mt-1">
                <div className="d-flex">
                  <span className="handling_sub_h">As subject teacher</span>
                  <div>
                    {subtec?.map((item, index) => (
                      <button className="btn_claasN1">{item}</button>
                    ))}
                  </div>
                </div>
                <div className="d-flex">
                  <span className="handling_sub_h2">As class teacher</span>
                  <div className="mt-1">
                    {substr?.map((item, index) => (
                      <button className="btn_claasN1">{item}</button>
                    ))}
                  </div>
                </div>
                <div className="d-flex">
                  <span className="handling_sub_h3">As coodinator</span>
                  <div className="mt-1">
                    {classStr?.map((item, index) => (
                      <button className="btn_claasN1">{item}</button>
                    ))}
                  </div>
                </div>
              </div>
            </div>



            <div className='col-6 profile_edit_btn2'>
              {/* <Link to='/SuccesfullyEditProfile'> */}
              <input
                id="Profile_edit_btn_both"
                type="submit"
                value="Submit Changes"
              />
              <input
                id="Profile_edit_btn_both"
                type="submit"
                value="Discard Changes"
                onClick={(e) => { setDiscard(true) }}

              />


            </div>
          </form>
        </div>
        {editSucess && <ChangeRequest setEditSucess={setEditSucess} setClick={setClick} setProfile={setProfile} />}
        {/* {editSucess && <EiditSuccesfully setEditSucess={setEditSucess}/>} */}
        {discard && <EditDisabled setDiscard={setDiscard} setClick={setClick} setProfile={setProfile} />}
      </div >

    </>
  )
}
